/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, ElementRef, HostListener } from "@angular/core";
import { Dropdown } from "./dropdown";
var DropdownItem = (function () {
    function DropdownItem(_dropdown, el) {
        this._dropdown = _dropdown;
        this.el = el;
    }
    DropdownItem.prototype.onDropdownItemClick = function () {
        if (this._dropdown.isMenuClosable && !this.el.nativeElement.classList.contains("disabled")) {
            this._dropdown.toggleDropdown();
        }
    };
    return DropdownItem;
}());
export { DropdownItem };
DropdownItem.decorators = [
    { type: Directive, args: [{
                selector: "[clrDropdownItem]",
                host: {
                    "[class.dropdown-item]": "true"
                }
            },] },
];
/** @nocollapse */
DropdownItem.ctorParameters = function () { return [
    { type: Dropdown, },
    { type: ElementRef, },
]; };
DropdownItem.propDecorators = {
    'onDropdownItemClick': [{ type: HostListener, args: ["click",] },],
};
//# sourceMappingURL=dropdown-item.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/dropdown/dropdown-item.js
// module id = 199
// module chunks = 4